// extracted by mini-css-extract-plugin
export default {"warnBanner":"GroupMapping_warnBanner__NE8WL"};